import { createRoot } from 'react-dom/client';
import Module from './index.jsx';

const renderApp = (containerId, moduleName) => {
  const container = document.getElementById(containerId);
  const root = createRoot(container);
  root.render(<Module name={moduleName} />);
};

window.ReactLead360 = {
  renderApp
};
